
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.267 6.45c-.732 0-1.338-.23-1.818-.693-.48-.462-.72-1.056-.72-1.782V.033h1.044v3.88c0 .461.138.836.414 1.124.276.282.636.423 1.08.423.438 0 .795-.14 1.071-.423.276-.288.414-.663.414-1.125V.033h1.035v3.942c0 .726-.24 1.32-.72 1.782-.474.462-1.074.693-1.8.693zm8.22-.117l-.55-1.368H8.13l-.54 1.368H6.491L9.03.033h.972l2.601 6.3h-1.116zm-1.963-4.95L8.49 4.038h2.088L9.524 1.383zm6.427-1.35c.402 0 .765.09 1.089.27.33.18.588.43.774.747.186.318.279.672.279 1.062 0 .594-.204 1.09-.612 1.485-.408.396-.918.594-1.53.594h-1.296v2.142H13.62v-6.3h2.33zm-.054 3.177c.168 0 .32-.027.459-.08.144-.055.267-.13.369-.226a.95.95 0 00.234-.35c.06-.139.09-.286.09-.442 0-.21-.051-.396-.153-.558a1.029 1.029 0 00-.405-.396 1.209 1.209 0 00-.594-.144h-1.242V3.21h1.242zm3.35 3.123v-6.3h1.035v6.3h-1.035z","fill":"#fff"}})])
          )
        }
      }
    